var ZipInActionTypeEnum;
(function (ZipInActionTypeEnum) {
    ZipInActionTypeEnum["submitZipCode"] = "submitZipCode";
    ZipInActionTypeEnum["zipCodeValid"] = "zipCodeValid";
    ZipInActionTypeEnum["zipCodeInvalid"] = "zipCodeInvalid";
    ZipInActionTypeEnum["zipCodeError"] = "zipCodeError";
    ZipInActionTypeEnum["zipCodeEmpty"] = "zipCodeEmpty";
    ZipInActionTypeEnum["forgetZipCode"] = "forgetZipCode";
    ZipInActionTypeEnum["resetErrors"] = "resetErrors";
    ZipInActionTypeEnum["servicesDone"] = "servicesDone";
})(ZipInActionTypeEnum || (ZipInActionTypeEnum = {}));
export default ZipInActionTypeEnum;
//# sourceMappingURL=ZipInActionTypeEnum.js.map